// Compiled at 2026-10-07T06:21:14.844Z
import { System } from "../../Module/$modules.js";

// Auto-generated by Lowgile
export const $ModuleId = 'Common';

export * from "../../Label/Common/$translations.js";
export * from "../../Resource/Common/$resources.js";
export * from "../../ConfigurationItem/Common/config.js";
export * as $Process from "../../Process/Common/$processes.js";
export * from "../../Role/Common/$roles.js";
export * from "../../Permission/Common/$permissions.js";
export * from "../../Screen/Common/$screens.js";
